module.exports = __webpack_public_path__ + "70b0b99a5bbdf7d288f0fa0662739999.png";